export default "__VITE_ASSET__CaNVI5sT__"